import { render, staticRenderFns } from "./ModalNews.vue?vue&type=template&id=2fd25262&"
import script from "./ModalNews.vue?vue&type=script&lang=js&"
export * from "./ModalNews.vue?vue&type=script&lang=js&"
import style0 from "./ModalNews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports